const debounce = (callback, wait = 1000) => {
  let timeoutId

  const debounced = function (...args) {
    const context = this

    if (timeoutId) {
      clearTimeout(timeoutId)
    }

    timeoutId = setTimeout(() => {
      callback.apply(context, args)
      timeoutId = null
    }, wait)
  }

  debounced.cancel = () => {
    if (timeoutId) {
      clearTimeout(timeoutId)
      timeoutId = null
    }
  }

  return debounced
}

const debouncePromise = (callback, wait = 1000) => {
  let timeoutId
  let pendingReject

  const debounced = function (...args) {
    const context = this

    if (timeoutId) {
      clearTimeout(timeoutId)
      timeoutId = undefined

      if (pendingReject) {
        pendingReject({ _cancelled: true })
      }
    }

    return new Promise((resolve, reject) => {
      pendingReject = reject

      timeoutId = setTimeout(async () => {
        timeoutId = undefined
        const currentReject = pendingReject
        pendingReject = undefined

        try {
          const result = await callback.apply(context, args)
          resolve(result)
        } catch (error) {
          if (currentReject === reject) {
            reject(error)
          }
        }
      }, wait)
    })
  }

  debounced.cancel = () => {
    if (timeoutId) {
      clearTimeout(timeoutId)
      timeoutId = undefined
    }

    if (pendingReject) {
      pendingReject({ _cancelled: true })
      pendingReject = undefined
    }
  }

  return debounced
}

export { debounce, debouncePromise }
